import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';

import './index.css';
import LoginPage from './pages/LoginPage.jsx';
import RegisterPage from './pages/RegisterPage.jsx';
import PasswordChangePage from './pages/PasswordChangePage.jsx';
import SchedulingPage from './pages/SchedulingPage.jsx';
import ReportsPage from './pages/ReportsPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import CreateAppointmentPage from './pages/CreateAppointmentPage.jsx';
import SleepingReportPage from './pages/sleepingReportPage.jsx';
import AutoSchedulingPage from './pages/AutoSchedulingPage.jsx';
import NewAutoSchedulingPage from './pages/NewAutoSchedulingPage.jsx';
import AmbassadorCheckInPage from './pages/AmbassadorCheckIn.jsx';
import NewAmbassadorCheckInPage from './pages/NewAmbassadorCheckIn.jsx';
import AmbassadorCheckInAdminPage from './pages/AmbassadorCheckInAdmin.jsx';
import AdminPage from './pages/AdminPage.jsx';
import AuthContext from './context/AuthContext'; // 正確導入 AuthContext
import BigScreenAdmin from './pages/BigScreenAdmin.jsx';
import GoogleTrial from './pages/GoogleSheetTrial.jsx';
import TempAmbassadorCheckInPage from './pages/TempAmbassadorCheckIn.jsx';
import DeviceMapStatusPage from './pages/DeviceMapStatusPage.jsx';
import SpaSystemGuestPage from './pages/SpaSystemGuestPage.jsx';
import OrgLoginPage from './pages/OrgLoginPage.jsx';
import DoubleOrgLoginPage from './pages/DoubleOrgLoginPage.jsx';
import NewAmbassadorCheckInNewDesignPage from './pages/NewAmbassadorCheckInNewDesign.jsx';

import H11_25_DB from './pages/org/H11_25.jsx';
import S38_89_DB from './pages/org/S38_89.jsx';
import S49_80_DB from './pages/org/S49_80.jsx';


import ConnectionCheckinPage from './pages/ConnectionCheckinPage.jsx';
import ConnectionPublicPage from './pages/ConnectionPublicPage.jsx';

import NewAromaPodProDeviceUXv1 from "./pages/NewAromaPodProDeviceUX.jsx";
import NewAromaPodProDeviceUXv2 from "./pages/NewAromaPodProDeviceUXv2.jsx";


// 創建 AuthProvider 組件
const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// ProtectedRoute 組件
const ProtectedRoute = ({ requiredRole }) => {
  const { user } = React.useContext(AuthContext);

  if (!user) {
    return <Navigate to="/login" />; // 未登入則重定向到登入頁
  }

  if (requiredRole) {
    // 檢查是否為組織管理員角色
    if (requiredRole === "orgAdmin" && user.role === "orgAdmin") {
      return <Outlet />; // 允許訪問
    }
    // 檢查其他角色
    else if (user.role !== requiredRole) {
      return <Navigate to="/" />; // 無權限則重定向到首頁
    }
  }

  return <Outlet />; // 允許訪問受保護的路由
};

// App 組件
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>

          <Route path="/checkin" element={<ConnectionCheckinPage />} />
          <Route path="/public" element={<ConnectionPublicPage />} />

          <Route path="/login" element={<LoginPage />} />
          <Route path="/org/login" element={<OrgLoginPage />} />
          <Route path="/org/loginx" element={<DoubleOrgLoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<PasswordChangePage />} />
          <Route path="/ambassador/checkIn" element={<NewAmbassadorCheckInPage />} />
          <Route path="/ambassador/checkInNew" element={<NewAmbassadorCheckInNewDesignPage />} />
          
          <Route path="/test/ambassador/checkintemp" element={<TempAmbassadorCheckInPage />} />
          <Route path="/spa-guest" element={<SpaSystemGuestPage />} />
          <Route path="/scheduling" element={<SchedulingPage />} />
          <Route path="/scheduling/create" element={<CreateAppointmentPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          {/* <Route path="/sleeping-report" element={<SleepingReportPage />} /> */}

          <Route path="/aromapodpro/UXUI/v1" element={<NewAromaPodProDeviceUXv1 />} />
          <Route path="/aromapodpro/UXUI/v2" element={<NewAromaPodProDeviceUXv2 />} />
          

          <Route element={<ProtectedRoute />}>
            <Route path="/db" element={<DashboardPage />} />
            <Route path="/bsa" element={<BigScreenAdmin />} />
            <Route path="/gt" element={<GoogleTrial />} />
          </Route>

          <Route element={<ProtectedRoute requiredRole="orgAdmin" />}>
            <Route path="/org/H11/25/db" element={<H11_25_DB />} />
            <Route path="/org/S38/89/db" element={<S38_89_DB />} />
            <Route path="/org/S49/80/db" element={<S49_80_DB />} />
          </Route>

          <Route element={<ProtectedRoute requiredRole="admin" />}>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/schedules" element={<AutoSchedulingPage />} />
            <Route path="/test/admin/schedules" element={<NewAutoSchedulingPage />} />
            <Route path="/admin/checkIn" element={<AmbassadorCheckInAdminPage />} />
          </Route>



          <Route element={<ProtectedRoute requiredRole="admin-super" />}>
            <Route path="/dms" element={<DeviceMapStatusPage />} />
          </Route>


          {/* 默認路由 */}
          <Route path="/" element={<LoginPage />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

// 渲染根組件
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);